export default __webpack_public_path__ + "static/media/pending.9ef65a13.svg";